export const HOTELPROFESSIONALS_HELP_ARTICLE_URL = 'https://support.recruitee.com/articles/3748440';
export const HOTELPROFESSIONALS_WEBSITE_URL = 'https://www.hotelprofessionals.nl/';

export const HOTELPROFESSIONALS_DEPARTMENTS = [
  { value: '5524', nameKey: 'accounting' },
  { value: '5526', nameKey: 'banquet_sales' },
  { value: '5527', nameKey: 'banqueting' },
  { value: '5528', nameKey: 'bar_restaurant_roomservice' },
  { value: '5529', nameKey: 'security' },
  { value: '5530', nameKey: 'concierge' },
  { value: '5532', nameKey: 'health_club' },
  { value: '5533', nameKey: 'housekeeping' },
  { value: '5534', nameKey: 'it' },
  { value: '5535', nameKey: 'kitchen' },
  { value: '5537', nameKey: 'management' },
  { value: '5538', nameKey: 'human_resources' },
  {
    value: '5539',
    nameKey: 'reception_guest_relations',
  },
  { value: '5540', nameKey: 'reservations_revenue_management' },
  { value: '5541', nameKey: 'sales_marketing' },
  { value: '5543', nameKey: 'stewarding' },
  { value: '5544', nameKey: 'maintenance' },
].map(({ value, nameKey }) => ({
  value,
  nameKey: `rti.hotelprofessionals.departments.${nameKey}`,
}));

export const HOTELPROFESSIONALS_FUNCTIONS = [
  { value: '736', nameKey: 'cluster_financial_controller' },
  { value: '737', nameKey: 'financial_controller' },
  { value: '738', nameKey: 'assistant_financial_controller' },
  { value: '739', nameKey: 'supervisor_accounting' },
  { value: '740', nameKey: 'accounts_receivable' },
  { value: '741', nameKey: 'accounting_employee' },
  { value: '742', nameKey: 'income_audit' },
  { value: '743', nameKey: 'general_manager' },
  { value: '746', nameKey: 'banquet_sales_manager' },
  { value: '747', nameKey: 'banquet_sales_executive' },
  { value: '748', nameKey: 'banquet_sales_coordinator' },
  { value: '749', nameKey: 'banquet_sales_supervisor' },
  { value: '750', nameKey: 'banqueting_manager' },
  { value: '751', nameKey: 'assistant_banqueting_manager' },
  { value: '752', nameKey: 'banqueting_supervisor' },
  { value: '753', nameKey: 'banqueting_shift_leader' },
  { value: '754', nameKey: 'banqueting_employee' },
  { value: '755', nameKey: 'banqueting_coordinator' },
  { value: '756', nameKey: 'bar_manager' },
  { value: '757', nameKey: 'assistant_bar_manager' },
  { value: '763', nameKey: 'bar_supervisor' },
  { value: '764', nameKey: 'security_manager' },
  { value: '765', nameKey: 'security_officer' },
  { value: '766', nameKey: 'head_concierge' },
  { value: '767', nameKey: 'concierge' },
  { value: '768', nameKey: 'doorman' },
  { value: '769', nameKey: 'baggage_handler' },
  { value: '770', nameKey: 'duty_manager' },
  { value: '771', nameKey: 'health_club_manager' },
  { value: '772', nameKey: 'health_club_employee' },
  { value: '773', nameKey: 'masseur' },
  { value: '774', nameKey: 'beauty_specialist' },
  { value: '775', nameKey: 'housekeeping_manager' },
  { value: '776', nameKey: 'assistant_housekeeping_manager' },
  { value: '777', nameKey: 'floorsupervisor' },
  { value: '778', nameKey: 'houseman' },
  { value: '779', nameKey: 'housekeeper' },
  { value: '780', nameKey: 'it_manager' },
  { value: '781', nameKey: 'it_employee' },
  { value: '782', nameKey: 'chef' },
  { value: '783', nameKey: 'sous_chef' },
  { value: '784', nameKey: 'chef_de_parti' },
  { value: '785', nameKey: 'demi_chef_de_parti' },
  { value: '786', nameKey: 'commis' },
  { value: '787', nameKey: 'breakfast_chef' },
  { value: '789', nameKey: 'hotel_manager' },
  { value: '790', nameKey: 'operations_manager' },
  { value: '791', nameKey: 'rooms_division_manager' },
  { value: '792', nameKey: 'food_and_beverage_manager' },
  { value: '795', nameKey: 'reservations_manager' },
  { value: '807', nameKey: 'human_resource_manager' },
  { value: '808', nameKey: 'training_manager' },
  { value: '809', nameKey: 'human_resource_agent' },
  { value: '810', nameKey: 'paymaster' },
  { value: '811', nameKey: 'front_office_manager' },
  { value: '812', nameKey: 'assistant_front_office_manager' },
  { value: '813', nameKey: 'supervisor_front_office' },
  { value: '814', nameKey: 'receptionist' },
  { value: '815', nameKey: 'night_receptionist' },
  { value: '821', nameKey: 'revenue_manager' },
  { value: '822', nameKey: 'revenue_coordinator' },
  { value: '823', nameKey: 'director_of_sales' },
  { value: '824', nameKey: 'assistant_director_of_sales' },
  { value: '825', nameKey: 'sales_manager' },
  { value: '826', nameKey: 'sales_executive' },
  { value: '827', nameKey: 'sales_coordinator' },
  { value: '830', nameKey: 'personal_assistant' },
  { value: '831', nameKey: 'stewarding_manager' },
  { value: '832', nameKey: 'steward' },
  { value: '833', nameKey: 'maintenance_manager' },
  { value: '834', nameKey: 'assistant_maintenance_manager' },
  { value: '835', nameKey: 'engineering_supervisor' },
  { value: '836', nameKey: 'engineer' },
  { value: '837', nameKey: 'cook' },
  { value: '838', nameKey: 'self_employed_cook' },
  { value: '840', nameKey: 'roomservice_manager' },
  { value: '841', nameKey: 'roomservice_employee' },
  { value: '843', nameKey: 'restaurant_manager' },
  { value: '845', nameKey: 'bartender' },
  { value: '847', nameKey: 'manager_reservations' },
  { value: '848', nameKey: 'shiftleader_reservations' },
  { value: '849', nameKey: 'reservations_agent' },
  { value: '852', nameKey: 'guest_relations_manager' },
  { value: '853', nameKey: 'guest_relations_officer' },
  { value: '854', nameKey: 'guest_relations_agent' },
  { value: '856', nameKey: 'call_centre_manager' },
  { value: '857', nameKey: 'call_centre_agent' },
  { value: '859', nameKey: 'marketing_manager' },
  { value: '860', nameKey: 'marketing_employee' },
  { value: '861', nameKey: 'chef_de_rang' },
  { value: '862', nameKey: 'restaurant_supervisor' },
  { value: '863', nameKey: 'waiter' },
  { value: '864', nameKey: 'hostess' },
  { value: '865', nameKey: 'breakfast_employee' },
  { value: '866', nameKey: 'accounts_payable' },
  { value: '867', nameKey: 'assistant_restaurant_manager' },
  { value: '868', nameKey: 'account_manager' },
  { value: '869', nameKey: 'storekeeper' },
  { value: '870', nameKey: 'f&b_cost_controller' },
  { value: '871', nameKey: 'linen_room_attendant' },
  { value: '872', nameKey: 'payroll_administrator' },
  { value: '873', nameKey: 'barista' },
  { value: '874', nameKey: 'minibar_employee' },
  { value: '875', nameKey: 'director_of_business_development' },
  { value: '877', nameKey: 'sommelier' },
  { value: '880', nameKey: 'f&b_employee' },
  { value: '884', nameKey: 'purchasing_employee' },
  { value: '886', nameKey: 'purchasing_manager' },
].map(({ value, nameKey }) => ({
  value,
  nameKey: `rti.hotelprofessionals.functions.${nameKey}`,
}));

export const FULL_TIME = '5038';
export const PART_TIME = '5039';
export const INTERNSHIP = '5040';

export const HOTELPROFESSIONALS_EMPLOYMENT_TYPES = [
  { value: FULL_TIME, nameKey: 'full_time' },
  { value: PART_TIME, nameKey: 'part_time' },
  { value: INTERNSHIP, nameKey: 'internship' },
].map(({ value, nameKey }) => ({
  value,
  nameKey: `rti.hotelprofessionals.employment_types.${nameKey}`,
}));

export const HOTELPROFESSIONALS_FEATURES = [
  { value: '711', nameKey: 'operational' },
  { value: '715', nameKey: 'managerial' },
].map(({ value, nameKey }) => ({
  value,
  nameKey: `rti.hotelprofessionals.features.${nameKey}`,
}));

export const HOTELPROFESSIONALS_EDUCATION = [
  { value: '716', label: 'MBO' },
  { value: '717', label: 'HBO' },
  { value: '719', label: 'MBO/HBO' },
  { value: '718', label: 'HBO+' },
  { value: '2744', nameKey: 'rti.hotelprofessionals.create_posting.not_applicable' },
];

export const HOTELPROFESSIONALS_EXPERIENCE = [
  { value: '720', label: '0 - 1' },
  { value: '721', label: '2 - 5' },
  { value: '722', label: '6 - 10' },
  {
    value: '2743',
    nameKey: 'rti.hotelprofessionals.create_posting.not_applicable',
  },
];

export const HOTELPROFESSIONALS_REQUIRED_LANGUAGES = [
  { value: 'Dutch', nameKey: 'dutch' },
  { value: 'English', nameKey: 'english' },
  { value: 'Portugees', nameKey: 'portugees' },
  { value: 'Italian', nameKey: 'italian' },
  { value: 'Polish', nameKey: 'polish' },
  { value: 'French', nameKey: 'french' },
  { value: 'Spanish', nameKey: 'spanish' },
  { value: 'German', nameKey: 'german' },
  { value: 'None', nameKey: 'none' },
].map(({ value, nameKey }) => ({
  value,
  nameKey: `rti.hotelprofessionals.required_languages.${nameKey}`,
}));
